<template>
    <div>
        <app-layout>
            <template v-slot:header>
                <Header :title="$t('minor_application')" :isFilter="false" :isNewButton="isNewButton"
                    @new-button-click="store()">
                    <template v-slot:columns>
                        <div class="mb-1" v-for="(column, key) in datatable.columns" :key="key">
                            <b-form-checkbox :id="'checkbox-' + key" :name="'checkbox-' + key" :value="false"
                                :unchecked-value="true" v-model="column.hidden" v-if="column.field != 'buttons'">
                                {{ column.label }}
                            </b-form-checkbox>
                        </div>
                    </template>
                </Header>
            </template>
            <template v-slot:header-mobile>
                <HeaderMobile :title="$t('minor_application')" :isFilter="false" :isNewButton="isNewButton"
                    @new-button-click="store()">
                    <template v-slot:columns>
                        <div class="mb-1" v-for="(column, key) in datatable.columns" :key="key">
                            <b-form-checkbox :id="'checkbox-' + key" :name="'checkbox-' + key" :value="false"
                                :unchecked-value="true" v-model="column.hidden" v-if="column.field != 'buttons'">
                                {{ column.label }}
                            </b-form-checkbox>
                        </div>
                    </template>
                </HeaderMobile>
            </template>

            <template v-if="!applicationActive && preferences.length < 1">
                <p class="body-1 h6 mb-2">
                    {{ $t("undergraduate_check_date_message") }}
                </p>
            </template>

            <b-card v-else-if="formKeyLength > 0">
                <template #header>
                    <div class="d-flex flex-row align-items-center">
                        <h5 class="mb-0">
                            {{ student.name }} {{ student.surname }}:
                        </h5>
                        <h6 class="ml-4 mb-0 text-secondary">
                            <template v-if="student.result">
                                <b-badge :variant="(student.result == 'placed'|| student.result == 'registered' ? 'success' : 'danger') + ' text-uppercase'">
                                    {{ $t(`application_result.${student.result}`) }}
                                </b-badge>
                            </template>
                            <template v-else>
                                <template v-if="!student.status">
                                    {{ $t('minor_status_obj.waiting') }}
                                </template>
                                <template v-else-if="student.status == 'waiting_preference'">
                                    {{ $t("application_send_waiting") }}
                                </template>
                                <template v-else-if="student.status == 'published'">
                                    {{ $t("published") }}
                                </template>
                                <template v-else>
                                    {{ $t("your_application_has_been_evaluated") }}
                                </template>
                            </template>
                        </h6>
                    </div>
                </template>
                <b-card-text>
                    <b-row>
                        <b-col cols="12" md="6" lg="4">
                            <b-form-group :label="$t('faculty')">
                                <div class="label-as-input">
                                    {{
                                        getObjectValue(student, "faculty_name")
                                    }}
                                </div>
                            </b-form-group>
                        </b-col>
                        <b-col cols="12" md="6" lg="4">
                            <b-form-group :label="$t('program')">
                                <div class="label-as-input">
                                    {{
                                        getObjectValue(student, "program_name")
                                    }}
                                </div>
                            </b-form-group>
                        </b-col>
                        <b-col cols="12" md="6" lg="4">
                            <b-form-group :label="$t('class')">
                                <div class="label-as-input">
                                    {{
                                        student.class
                                        ? $t("class_x", {
                                            class: student.class,
                                        })
                                        : "-"
                                    }}
                                </div>
                            </b-form-group>
                        </b-col>
                        <b-col cols="12" md="6" lg="4">
                            <b-form-group :label="$t('number_of_semesters')">
                                <div class="label-as-input">
                                    {{
                                        getObjectValue(
                                            student,
                                            "semester_count"
                                        )
                                    }}
                                </div>
                            </b-form-group>
                        </b-col>
                        <b-col cols="12" md="6" lg="4">
                            <b-form-group :label="$t('student_number')">
                                <div class="label-as-input">
                                    {{ student.student_number }}
                                </div>
                            </b-form-group>
                        </b-col>
                        <b-col cols="12" md="6" lg="4">
                            <b-form-group :label="$t('registration_type_1')">
                                <div class="label-as-input">
                                    {{
                                        getLocaleText(
                                            student,
                                            "registration_type_text"
                                        ) ||
                                        getLocaleText(
                                            student.registration_type,
                                            "name"
                                        )
                                    }}
                                </div>
                            </b-form-group>
                        </b-col>
                        <b-col cols="12" md="6" lg="4">
                            <b-form-group :label="$t('registration_date')">
                                <div class="label-as-input">
                                    {{
                                        toLocaleDate(student.registration_date)
                                    }}
                                </div>
                            </b-form-group>
                        </b-col>
                        <b-col cols="12" md="6" lg="4">
                            <b-form-group :label="$t('prep_status')">
                                <div class="label-as-input">
                                    {{
                                        getLocaleText(
                                            student,
                                            "prep_status_text"
                                        ) ||
                                        getLocaleText(
                                            student.prep_status,
                                            "name"
                                        )
                                    }}
                                </div>
                            </b-form-group>
                        </b-col>
                        <b-col cols="12" md="6" lg="4">
                            <b-form-group :label="$t('gno')">
                                <div class="label-as-input">
                                    {{ getObjectValue(student, "cgpa") }}
                                </div>
                            </b-form-group>
                        </b-col>
                        <b-col cols="12" md="6" lg="4"
                            v-if="student.student_program?.student?.person?.nationality_code != 'TR' && student.nationality_code != 'TR'">
                            <b-form-group :label="$t('equivalence_status')">
                                <div class="label-as-input">
                                    {{
                                        student.equivalence_status
                                        ? $t("there_is")
                                        : $t("none")
                                    }}
                                </div>
                            </b-form-group>
                        </b-col>
                    </b-row>
                </b-card-text>

                <button class="btn btn-primary" v-if="!student.status" @click="start">
                    {{ $t("minor_application_start") }}
                </button>
            </b-card>

            <b-alert v-if="errMessage" show variant="secondary"> <span class="body-1">{{ $t('api.' + errMessage) }}</span>
            </b-alert>

            <template v-if="student.status">
                <b-row class="py-2">
                    <b-col cols="12" class="mb-4 mt-2" v-if="preferences.length > 0">
                        <h5 class="mb-0">{{ $t("your_preferences") }}</h5>
                    </b-col>
                    <b-col cols="12" class="mb-4" v-if="student.status == 'waiting_preference'">
                        <div class="d-flex align-items-center justify-content-between">
                            <h5 class="mb-0">
                                {{ getLocaleText(student, "status_text") }}
                            </h5>

                            <button class="btn btn-secondary" @click="editableOn" v-if="preferences.length > 0">
                                {{
                                    preferenceEditable
                                    ? $t("close_editing")
                                    : $t("preferences_order_change")
                                }}
                            </button>
                        </div>
                    </b-col>
                </b-row>

                <b-row>
                    <!-- <b-col cols="12" :style="{flexWrap:'wrap'}" > -->
                    <template v-for="(preferenceItem, index) in preferences">
                        <minorPreference @changeRank="changeRank" :preferenceEditable="preferenceEditable"
                            :index="preferenceItem.rank" :value="preferenceItem" @getItems="getPreferences"
                            @updateValue="(e) => (preferences[index] = e)" :key="index" />
                    </template>
                    <!-- </b-col> -->

                    <!-- <draggable v-show="preferenceEditable" v-model="changePreferences" @end="onEnd"
                        class="preference-draggable row">
                        <transition-group>
                            <template v-for="( preferenceItem, index ) in  changePreferences ">
                                <minorPreference :value="preferenceItem" :index="index + 1" :key="preferenceItem.id" />
                            </template>
                        </transition-group>
                    </draggable> -->
                </b-row>
                <b-row>
                    <b-col cols="6" class="mb-4 mt-2 text-left" v-if="student.status == 'waiting_preference'">
                        <button class="btn btn-primary" @click="formShow('add')">
                            {{ $t("add_preference1") }}
                        </button>
                    </b-col>
                    <b-col cols="6" class="mb-4 mt-2"
                        v-if="preferences.length > 0 && student.status == 'waiting_preference'">
                        <button class="btn btn-primary float-right" v-if="!preferenceEditable" @click="sendPreference">
                            {{ $t("application_send") }}
                        </button>
                    </b-col>
                </b-row>
                <hr />
            </template>

            <!-- Datatable -->
            <datatable :isLoading.sync="datatable.isLoading" :columns="datatable.columns" :rows="datatable.rows"
                :total="datatable.total" :queryParams="datatable.queryParams" :lineNumbers="false"
                @on-page-change="onPageChange" @on-sort-change="onSortChange" @on-per-page-change="onPerPageChange"
                v-show="datatable.showTable" :title="$t('applications')" />

            <!-- Modals -->
            <CommonModal ref="preferenceModal" size="lg" :footer="true">
                <template v-slot:CommonModalTitle>
                    {{ $t("new").toUpper() }} {{ $t("preference").toUpper() }}
                </template>
                <template v-slot:CommonModalContent>
                    <preferenceForm ref="preferenceDataForm" v-model="preference" />
                </template>
                <template v-slot:CommonModalFooter>
                    <button class="btn btn-primary" @click="preferenceSave">
                        {{ $t("add_preference1") }}
                    </button>
                </template>
            </CommonModal>

            <CommonModal ref="preferenceFormModal" size="xxl" :onHideOnlyX="true"
                @bHideModalHeaderClose="preferenceFormClose()" v-if="checkPermission('minorapplicationpreference_store')">
                <template v-slot:CommonModalTitle>
                    {{ $t("your_preferences").toUpper() }}
                </template>
                <template v-slot:CommonModalContent>
                    <create-form @createFormSuccess="createFormSuccess" v-if="formProcess == 'create'" />
                </template>
            </CommonModal>
        </app-layout>
    </div>
</template>
<script>
// Template
import AppLayout from "@/layouts/AppLayout";
import Header from "@/layouts/AppLayout/Header";
import HeaderMobile from "@/layouts/AppLayout/HeaderMobile";

// Component
import DatatableFilter from "@/components/datatable/DatatableFilter";
import Datatable from "@/components/datatable/Datatable";
import CommonModal from "@/components/elements/CommonModal";

// Page
import PreferenceForm from "./PreferenceForm";

// Service
import MinorApplicationService from "@/services/MinorApplicationService";

export default {
    name: "MinorApplicationStudent",
    components: {
        AppLayout,
        Header,
        HeaderMobile,
        DatatableFilter,
        Datatable,
        CommonModal,
        PreferenceForm,
        minorPreference: () => import("./components/minorPreference"),
        preferenceForm: () => import("./components/preferenceForm"),
    },
    metaInfo() {
        return {
            title: this.$t("minor_application"),
        };
    },
    data() {
        return {
            errMessage: "",
            loadingPage: false,
            loadingApplications: false,
            isNewButton: false,
            showExtraStudentInfo: false,
            student: {},
            loading: false,
            form: {},
            formId: null,
            formProcess: null,
            applications: [],
            applicationActive: false,
            preference: {},
            preferences: [],
            changePreferences: [],
            preferenceType: "",
            preferenceEditable: false,
            changePreference: [],
            datatable: {
                isLoading: false,
                columns: [
                    {
                        label: "",
                        field: "buttons",
                        html: true,
                        sortable: false,
                        tdClass: "p-0 text-center w-40 align-middle",
                        buttons: [
                            {
                                text: this.$t("your_preferences"),
                                class: "ri-edit-box-line",
                                permission: "minorapplicationpreference_store",
                                callback: (row) => {
                                    this.preferenceFormShow(row);
                                },
                                show: (row) => {
                                    if (row.status == "waiting_preference") {
                                        return false;
                                    } else {
                                        return true;
                                    }
                                },
                            },
                            {
                                text: this.$t("edit_preference"),
                                class: "ri-edit-box-line",
                                permission: "minorapplicationpreference_store",
                                callback: (row) => {
                                    this.preferenceFormShow(row);
                                },
                                show: (row) => {
                                    if (row.status == "waiting_preference") {
                                        return true;
                                    } else {
                                        return false;
                                    }
                                },
                            },
                            {
                                text: this.$t("delete"),
                                class: "ri-delete-bin-2-line",
                                permission: "minorapplication_delete",
                                callback: (row) => {
                                    this.delete(row.id);
                                },
                                show: (row) => {
                                    if (row.status == "waiting_preference") {
                                        return true;
                                    } else {
                                        return false;
                                    }
                                },
                            },
                        ],
                    },
                    {
                        label: this.$t("id").toUpper(),
                        field: "id",
                        sortable: false,
                        hidden: true,
                        tdClass: "align-middle",
                    },
                    {
                        label:
                            this.$t("period").toUpper() +
                            " / " +
                            this.$t("semester").toUpper(),
                        field: "semester",
                        sortable: true,
                        hidden: false,
                        tdClass: "align-middle",
                        formatFn: (value, row) => {
                            return (
                                row.academic_year +
                                " / " +
                                this.getSemester(value)
                            );
                        },
                    },
                    {
                        label: this.$t("your_preferences").toUpper(),
                        field: "minor_application_preferences",
                        sortable: false,
                        hidden: false,
                        tdClass: "align-middle",
                        formatFn: (value) => {
                            let html = "";
                            if (value.length > 0) {
                                html += '<ol class="pl-2 m-0">';
                                value.forEach((item) => {
                                    html +=
                                        "<li>" +
                                        item.faculty_name +
                                        "<br>" +
                                        item.program_name +
                                        "</li>";
                                });
                                html += "</ol>";
                            }

                            return html;
                        },
                    },
                    {
                        label: this.$t("prep_score").toUpper(),
                        field: "prep_score",
                        sortable: false,
                        hidden: false,
                        tdClass: "align-middle",
                        formatFn: (value) => {
                            return value != null ? value : "-";
                        },
                    },
                    {
                        label: this.$t("result").toUpper(),
                        field: "approved_faculty",
                        sortable: false,
                        hidden: false,
                        tdClass: "align-middle",
                        formatFn: (value, row) => {
                            if (row.approved_faculty && row.approved_program) {
                                return (
                                    row.approved_faculty +
                                    "<br>" +
                                    row.approved_program
                                );
                            } else {
                                return "-";
                            }
                        },
                    },
                    {
                        label: this.$t("status").toUpper(),
                        field: "status",
                        sortable: false,
                        hidden: false,
                        tdClass: "align-middle",
                        formatFn: (value, row) => {
                            let variant = "badge-light";
                            if (value.includes("waiting"))
                                variant = "badge-warning";
                            else if (value == "declined")
                                variant = "badge-danger";
                            else if (value == "approved")
                                variant = "badge-success";

                            return (
                                '<span class="badge ' +
                                variant +
                                '">' +
                                row.status_text +
                                "</span>"
                            );
                        },
                    },
                ],
                rows: [],
                total: 0,
                filterStatus: true,
                showTable: false,
                queryParams: {
                    filter: {},
                    sort: "id",
                    page: 1,
                    limit: 20,
                },
            },
        };
    },
    watch: {
        "student.status": {
            handler(val) {
                if (val) {
                    this.getPreferences();
                }
            },
        },
    },
    computed: {
        formKeyLength() {
            return Object.keys(this.student).length
        },
    },
    async created() {
        await this.checkDate();
        // await this.getForm();
        await this.showApplication();
    },
    methods: {
        async editableOn() {
            this.preferenceEditable = !this.preferenceEditable;

            if (!this.preferenceEditable) {
                if (this.changePreferences.length < 1) return;

                // const rank = this.changePreferences.map((item, index) => ({
                //     minor_application_preference_id: item.id,
                //     rank: index + 1,
                // }))

                const rank = this.preferences.map((item) => ({
                    minor_application_preference_id: item.id,
                    rank: item.rank,
                }));

                const response = await MinorApplicationService.changeRank({
                    rank: rank,
                }).catch((e) =>
                    this.$toast.error(this.$t("api." + e.data.message))
                );
                if (response.data.success) {
                    this.changePreferences = [];
                    this.getPreferences();
                }

                this.$toast.success(this.$t("api." + response.data.message));
            }
        },
        changeRank(e) {
            const data = { ...e };
            const index = this.preferences.findIndex(
                (item) => item.rank === data.new && item.id !== data.id
            );
            if (index > -1) {
                this.preferences[index].rank = data.old;
            }
        },
        async sendPreference() {
            this.$swal
                .fire({
                    text: this.$t("are_you_sure_make_application"),
                    showCancelButton: true,
                    confirmButtonText: this.$t("yes"),
                    cancelButtonText: this.$t("no"),
                    icon: "question",
                })
                .then(async (result) => {
                    if (result.isConfirmed) {
                        const response =
                            await MinorApplicationService.savePreference().catch((e) =>
                                this.$toast.error(this.$t("api." + e.data.message))
                            );

                        if (response.data.success) {
                            this.showApplication();
                            this.getPreferences();
                        }
                        this.$toast.success(this.$t("api." + response.data.message));
                    }
                });
        },
        async preferenceSave() {
            const valid = await this.$refs["preferenceDataForm"].$refs[
                "formModalValidate"
            ].validate();
            if (!valid) {
                return;
            }

            const response = await MinorApplicationService.makePreference({
                program_code: this.preference.program_code,
                rank: this.preference.rank,
            }).catch((e) =>
                this.$toast.error(this.$t("api." + e.data.message))
            );

            if (response.data.success) {
                this.$refs.preferenceModal.$refs.commonModal.hide();
                this.preference = {};
                this.getPreferences();
            }
            this.$toast.success(this.$t("preference_add"));
        },
        formShow(type) {
            this.$refs.preferenceModal.$refs.commonModal.show();
            this.preferenceType = type;
        },
        async getPreferences() {
            const response = await MinorApplicationService.getPreferences();
            if (response.data.success) {
                this.preferences = response.data.data;
                this.changePreferences = response.data.data;
            }
        },
        async start() {
            const response =
                await MinorApplicationService.makeApplication().catch((e) =>
                    this.$toast.error(this.$t("api." + e.data.message))
                );

            if (response.data.success) {
                await this.showApplication();
            }
            this.$toast.success(
                this.$t("preference_please_add")
            );
        },
        async showApplication() {
            const response =
                await MinorApplicationService.showApplication().catch(() => {
                    this.getForm();
                });

            if (response.data.success) {
                this.student = response.data.data;
            }
        },
        filter() {
            this.getRows();
        },
        filterClear() {
            this.datatable.queryParams.filter = {};
            this.getRows();
        },
        onPageChange(params) {
            this.datatable.queryParams.page = params.currentPage;
            this.getRows();
        },
        onPerPageChange(params) {
            this.datatable.queryParams.limit = params.currentPerPage;
            this.datatable.queryParams.page = 1;
            this.getRows();
        },
        onSortChange(params) {
            const sortType = params[0].type == "desc" ? "-" : "";
            this.datatable.queryParams.sort = sortType + params[0].field;
            this.getRows();
        },
        getRows() {
            this.datatable.showTable = true;
            this.datatable.isLoading = true;

            return MinorApplicationService.getAll()
                .then((response) => {
                    this.datatable.rows = response.data.data;
                    this.datatable.total = response.data.pagination.total;
                })
                .then(() => {
                    this.isNewButton =
                        this.datatable.rows.filter((item) =>
                            item.status.includes("waiting")
                        ).length > 0
                            ? false
                            : true;
                })
                .finally(() => {
                    this.datatable.isLoading = false;
                });
        },
        async checkDate() {
            try {
                await MinorApplicationService.checkDate()
                this.applicationActive = true;
            } catch (error) {
                this.applicationActive = false;
                this.$toast.error(this.$t("undergraduate_check_date_message"))
            }
        },
        async getForm() {
            this.loadingPage = true;
            const response =
                await MinorApplicationService.studentForm()
                    .catch((e) => {
                        this.errMessage = e.data.message
                        this.showErrors(e);
                    })
                    .finally(() => {
                        this.loadingPage = false;
                    });
            if (response.data.success) {
                this.student = response.data.data;
            }
        },
        store() {
            MinorApplicationService.store()
                .then((response) => {
                    let data = response.data.data;
                    this.preferenceFormShow(data);
                    this.getRows();
                })
                .catch((e) => {
                    this.showErrors(e);
                });
        },
        delete(id) {
            this.$swal
                .fire({
                    text: this.$t("are_you_sure_to_delete"),
                    showCancelButton: true,
                    confirmButtonText: this.$t("yes"),
                    cancelButtonText: this.$t("no"),
                    icon: "question",
                })
                .then((result) => {
                    if (result.isConfirmed) {
                        MinorApplicationService.del(id)
                            .then((response) => {
                                this.$toast.success(
                                    this.$t("api." + response.data.message)
                                );
                                this.getRows();
                            })
                            .catch((error) => {
                                this.$toast.error(
                                    this.$t("api." + error.data.message)
                                );
                            });
                    }
                });
        },

        // Form Clear
        formClear() {
            this.formData = null;
            this.formProcess = null;
        },

        // Update Form
        preferenceFormShow(data) {
            this.formData = data;
            this.formProcess = "preference";
            this.$refs.preferenceFormModal.$refs.commonModal.show();
        },
        preferenceFormClose() {
            this.$refs.preferenceFormModal.$refs.commonModal.hide();
            this.getRows();
            this.formClear();
        },
    },
};
</script>

<style lang="scss">
.preference-draggable {
    width: 100%;

    span {
        width: 100%;
        // display: flex;
        // flex-wrap: wrap;
    }
}
</style>
